import { ReactElement } from 'react';
import { Loader } from 'b2b-components/theme/components/Loader';

export const FallbackLoader = (): ReactElement => (
  <div>
    <Loader />
  </div>
);
